<div class="row news-update-card mb-10">
    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <app-calculation-preferences-pass-pct
                [form]="form"
                [passCount]="4"
                [dataSource]="passPercentageData"
                style="height: 100%"
            ></app-calculation-preferences-pass-pct>
        </div>
    </div>

    <div class="col-md-6">
        <div class="card card-custom gutter-b card-stretch">
            <app-calculation-preferences-calc-results [form]="form" [dataSource]="calcResultsData"></app-calculation-preferences-calc-results>
        </div>
    </div>
</div>

<div class="row news-update-card">
    <div class="col-md-12">
        <div class="card card-custom card-stretch">
            <app-calculation-preferences-other [form]="form" [dataSource]="otherData"></app-calculation-preferences-other>
        </div>
    </div>
</div>
